import classes from './spinner.module.css';

/**
 * @returns {React.JSX.Element}
 */
export function Spinner() {
  return <div className={classes.spinner} />;
}
